(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dual-range-bar", [], factory);
	else if(typeof exports === 'object')
		exports["dual-range-bar"] = factory();
	else
		root["dual-range-bar"] = factory();
})(self, () => {
return 